import { createAction } from '@reduxjs/toolkit'

import { StatusBannerData } from 'utils/types'

// tryGetInternalStatusBanner
export const getAll = createAction('get_internal_status_banners')
export const getAllSuccess = createAction<{ data: StatusBannerData[] }>(
  'get_internal_status_banners_success'
)
export const getAllFailed = createAction('get_internal_status_banners_failed')

// tryCreateStatusBanner
export const create = createAction('create_internal_status_banner')
export const createSuccess = createAction<{ data: StatusBannerData }>(
  'create_internal_status_banner_success'
)
export const createFailed = createAction(
  'create_internal_status_banner_failed'
)

// tryUpdateStatusBanner
export const update = createAction('update_internal_status_banner')
export const updateSuccess = createAction<{ data: StatusBannerData }>(
  'update_internal_status_banner_success'
)
export const updateFailed = createAction(
  'update_internal_status_banner_failed'
)

// tryDeleteStatusBanner
export const destroy = createAction('destroy_internal_status_banner')
export const destroySuccess = createAction<{ id: string }>(
  'destroy_internal_status_banner_success'
)
export const destroyFailed = createAction(
  'destroy_internal_status_banner_failed'
)
